import {
  ActivatedRoute,
  DefaultUrlSerializer,
  Router
} from "@angular/router";
import { Filtro } from "../filtri/filtri.type";

export class UriHandler {
  FILTER_FIELD: string = "crudfilters";
  CRUD_FIELD: string = "crudSettings";
  private defaultUrlSerializer: DefaultUrlSerializer = new DefaultUrlSerializer();

  constructor(
    private router: Router
  ) { }

  has(nomeFiltro: string, route: ActivatedRoute) {
    return route.snapshot.queryParams[nomeFiltro] !== undefined;
  }

  get(fieldName: string) {
    let filters: string;

    let route = this.getCurrentRoute(decodeURI(window.location.href));
    if (route.queryParams[fieldName]) {
      try {
        filters = atob(route.queryParams[fieldName]);
        return JSON.parse(filters);
      } catch (e) {
        //filtro non corretto
        console.error("Data non corretti");
      }
    }
  }

  set(fieldName: string, values: any) {
    const stringData = JSON.stringify(values);
    let route = this.getCurrentRoute(window.location.href);
    const queryParams: any = Object.assign({}, route.queryParams);

    // Do something with the params
    queryParams[fieldName] = btoa(stringData);
    const urlTree = this.router.createUrlTree([], {
      queryParams: queryParams,
      // replaceUrl: true
    });
    const url = this.defaultUrlSerializer.serialize(urlTree);
    window.history.replaceState({}, document.title, url);
  }

  getFiltri(route: ActivatedRoute) {
    return this.get(this.FILTER_FIELD);
  }

  setFiltriQueryParams(filtri: Filtro[], route: ActivatedRoute) {
    this.set(this.FILTER_FIELD, filtri);
  }

  getCurrentRoute(url) {
    const qp = this.getQueryParams(url);
    return this.router.parseUrl(qp);
  }
  getQueryParams(url: string) {
    const pos = url.indexOf("?");
    if (pos !== -1) {
      return url.substr(pos);
    } else {
      return "";
    }
  }
}